import { styled } from 'next-yak';

export const BenefitsSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const Headline = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
